module.exports = __webpack_public_path__ + "img/dell_280x120.cdc443da.svg";